import { string } from "prop-types";
import React from "react";

class analyticsService {
    dumbleData: any;

    constructor(){
        this.dumbleData = {
            domain: {
                audience: "",
                channel: "",
                experience: "",
                experienceType: "",
                name: "",
            },
            page: {
                name: "",
                type: "", 
            },
            account: {
                accountNum: "",
                fairNum: "",
                orgUCN: "",
            }
        };
    }

    initDumbleData() {
        const dumble = {
            domain: {
                audience: "Consumer",
                channel: "Parents",
                experience: "Book Fairs",
                experienceType: "Commerce",
                name: "Parents",
            }
        }
        this.updateDumbleData("domain", dumble.domain);
    }

    updateDumbleData(fieldName: any, fieldValue: any){
          // updates the fieldName inside dumbleData to the fieldValue
        if (typeof(fieldValue) === "object") {
            if (this.dumbleData[fieldName] === undefined){
                this.dumbleData[fieldName] = {};
            }
            Object.assign(this.dumbleData[fieldName], fieldValue);
        } else {
            this.dumbleData[fieldName] = fieldValue;
        }
        window.dumbleData = this.dumbleData;
        
    }

    initDumblePage(pageName: string) {
        this.initDumbleData();
        const dumblePage = {
            page: {
                name: pageName,
                type: "Payment Portal"
            }
        }
        this.updateDumbleData("page", dumblePage.page);
    }

    updateDumblePage(newPageName: string) {
        const dumblePage = {
            page: {
                name: newPageName,
            }
        }
        this.updateDumbleData("page", dumblePage.page);    

    }

    setDumbleCreditCartInfo(payCard: string, payMethod: string, payAmt: string, payTax: string, orderId: string) {
        const dumbleCart = {
            cart: {
                payment: {
                    card: payCard,
                    method: payMethod,
                },
                totalPrice: payAmt,
                tax: payTax,
                orderID: orderId
            }
        }
        this.updateDumbleData("cart", dumbleCart.cart);
    }

    setDumbleEPaymentCartInfo(newPageName: string, payMethod: string, payAmt: string, payTax: string, walletId: string, orderId: string) {
        this.initDumblePage(newPageName);
        const dumbleCart = {
            cart: {
                payment: {
                    method: payMethod,
                },
                totalPrice: payAmt,
                tax: payTax,
                walletID: walletId,
                orderId: orderId,
            }
        }
        this.updateDumbleData("cart", dumbleCart.cart);
    }

    setDumbleERefundCartInfo(newPageName: string, payMethod: string, totalRefundAmount: string, partialRefund: boolean, walletId: string, orderId: string) {
        this.initDumblePage(newPageName);
        const dumbleCart = {
            cart: {
                payment: {
                    method: payMethod,
                },
                totalRefundAmount: totalRefundAmount,
                partialRefund: partialRefund,
                walletID: walletId,
                orderID: orderId,
            }
        }
        this.updateDumbleData("cart", dumbleCart.cart);
    }

}

export default analyticsService;